import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Chip from "material-ui/Chip";
import Radio, { RadioGroup } from "material-ui/Radio";
import List, { ListItem, ListItemText } from "material-ui/List";
import Divider from "material-ui/Divider";
import { toast } from "react-toastify";
import Qualification from "./qualification"
import FiberQualification from "./fiberqualification"

import {
  getQualification,
  getFiberLengthLoss
} from "../../../redux/actions";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  FormGroup
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { connect } from "react-redux";

import { DraggableModalFrame, ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import generateNames from "../../../common/namegenerate";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";

import Tooltip from "material-ui/Tooltip";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#5a5a5a",
    color: "white",
    maxWidth: "auto",
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #dadde9"
  }
}))(Tooltip);

class NewQualificationTest extends React.Component {
  constructor(props) {
    super(props);
    const { job, type, userPreference } = props;
    let withIdentifiers = job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview);
    let allowedTabs = withIdentifiers ? [ "tab_details", "tab_identifiers", type === "fiber" ? "tab_fiber_qualification" : "tab_qualification" ]
                                      : [ "tab_details", type === "fiber" ? "tab_fiber_qualification" : "tab_qualification" ];
    this.state = {
      open: true,
      errors: {},
      tabs: allowedTabs,
      tabPosition: 0,
      testPrefixType: "custom",
      test: {
        jobid: job.id,
        prefix: "",
        startvalue: "01",
        endvalue: "24",
        names: null,
        floor: "",
        telecommunicationspace: "",
        panel: "",
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ],
      },
      disabledToogleIdentifier: false,
      testCount: 0,
      isSubTestError: false,
      tabView: allowedTabs[0],
      selectedTestResult: null,
      qualification: null,
      fiberQualification: null,
      testIDType: "sequential",
      lantekfiles: null,
      modalRef: React.createRef()
    };
    this.onChangeMetadataField = this.onChangeMetadataField.bind(this);
    this.checkForAlreadySelectedSubtests = this.checkForAlreadySelectedSubtests.bind(
      this
    );
    this.checkForAlreadySelectedSubtestsSignaltek = this.checkForAlreadySelectedSubtestsSignaltek.bind(
      this
    );
    this.handleImport = this.handleImport.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  componentWillUnmount() {
    const { sessionStorage } = window;
    sessionStorage.removeItem("QTDEFAULT");
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      qualification
    } = prevProps;
    if (qualification && this.props.qualification != qualification) {
      this.setState({ qualification });
    }
  }

  checkForAlreadySelectedSubtests = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;
    if (
      (job.metadatalookupid === CUSTOM_METADATA_STANDARD || userPreference.FromTreeview) &&
      userPreference.metadata
    ) {
      let metadata = [...userPreference.metadata];
      let curStateMetaData = [...test.metadata];
      metadata.forEach(e => {
        curStateMetaData.forEach(ce => {
          if (ce.level === e.level) {
            ce.field = e.field;
            ce.value = e.value;
            e.value ? (ce.enabled = true) : (ce.enabled = false);
          }
        });
      });
      test.metadata = curStateMetaData;
      test.allmetadataoptions = true;
      this.setState({
        test: {
          ...test
        }
      });
    }
  };
  checkForAlreadySelectedSubtestsSignaltek = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;

    this.setState({
      testCount,
      isSubTestError: false
    });
  };

  handleTabChange = (event, value) => {
    let { tabPosition, tabs } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value, tabView: tabs[value] });
    }
  };

  tabNext() {
    const { tabs, tabPosition } = this.state;
    const { userPreference } = this.props;
    let pos = tabPosition + 1;
    let check = this.canTabNext();
    if (this.props.job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
      if (tabPosition > 1) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    } else {
      if (tabPosition > 0) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    }
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    const { tabs, tabPosition } = this.state;
    let check = this.canTabBack();
    if (check.can)
      this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;

    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    //this.setState({ tabPosition: 0, tabView: this.state.tabs[0] });

    this.props.handleClose();
    this.props.cancel("cancel");
  };

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  onChange = e => {
    const self = this;
    let test = { ...this.state.test };
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (
      e.target.name === "startvalue" &&
      e.target.value.trim() === "" &&
      test.startvalue === ""
    ) {
      return;
    }
    const { job, translate } = this.props;
    let value;
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      if (e.target.name === "floor")
        value =
          e.target.value.length <= 3 ? e.target.value : test[e.target.name];
      if (e.target.name === "telecommunicationspace")
        value =
          e.target.value.length <= 1 ? e.target.value : test[e.target.name];
      if (e.target.name === "panel")
        value =
          e.target.value.length <= 2 ? e.target.value : test[e.target.name];
      if (e.target.name === "startvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
      if (e.target.name === "endvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
    }

    if (e.target.name === "qualifyspeedid") {
      // TODO
    }

    test[e.target.name] = value ? value : e.target.value;
    if (e.target.name === "startvalue") {
      test["endvalue"] = value ? value : e.target.value;
    }
    // if (e.target.name === "endvalue") {
    //   test["endvalue"] = value ? value : e.target.value;
    // }
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
    }

    if (
      this.state.testIDType == "sequential" &&
      test.startvalue &&
      test.endvalue &&
      test.prefix
    ) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        2000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        if (this.state.testIDType != "import") test.names = null;
      }
    } else {
      if (this.state.testIDType != "import") test.names = null;
    }
    this.setState({ test, errors });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value,
      value: ""
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let field;
    const { custom } = this.props;
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    if (metadataOption.field == null) {
      field = custom.find(c => c.level == e.target.name).values[0].id;
      metadataOption = {
        value,
        field
      };
    } else {
      metadataOption = {
        value
      };
    }

    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const { test, tabPosition, testCount, tabs, testIDType } = this.state;
    const { job, translate } = this.props;
    let validationData = {};
    let errors = {};
    if (tabPosition < 2 || currentTab) {
      switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
        case 0:
          if (testIDType == "sequential") {
            if (
              job.metadatalookupid !== null &&
              job.metadatalookupid !== CUSTOM_METADATA_STANDARD
            ) {
              validationData = {
                floor: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 3,
                    message: translate("formfield_error_general_length", {
                      value: 3
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                telecommunicationspace: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 1,
                    message: translate("formfield_error_general_length", {
                      value: 1
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                panel: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 2,
                    message: translate("formfield_error_general_length", {
                      value: 2
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                startvalue: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 4,
                    message: translate("formfield_error_general_length", {
                      value: 4
                    })
                  },
                  type: {
                    value: "numeric",
                    message: translate("formfield_error_general_type_numeric")
                  }
                },
                endvalue: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 4,
                    message: translate("formfield_error_general_length", {
                      value: 4
                    })
                  },
                  type: {
                    value: "numeric",
                    message: translate("formfield_error_general_type_numeric")
                  }
                }
              };
            } else {
              validationData = {
                prefix: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                startvalue: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                  // length: {
                  //   value: 4,
                  //   message: translate("formfield_error_general_length", {
                  //     value: 4
                  //   })
                  // }
                },
                endvalue: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                  // length: {
                  //   value: 4,
                  //   message: translate("formfield_error_general_length", {
                  //     value: 4
                  //   })
                  // }
                }
              };
            }
          }
          break;
        case 1:
          test.metadata.map(x => {
            if (x.enabled && x.field != null && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.field != null && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
          break;
        default:
          return true;
      }
      if (testIDType == "sequential" && tabPosition === 0) {
        if (!this.state.test.names) {
          errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
            "test_maximum_allowed_range"
          )} ]`;
          errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
            "test_maximum_allowed_range"
          )} ]`;
        }
      }

      if (
        (tabPosition === 1 &&
          job.metadatalookupid === CUSTOM_METADATA_STANDARD) ||
        (currentTab && job.metadatalookupid === CUSTOM_METADATA_STANDARD)
      ) {
      } else {
        errors = validateFormData(test, validationData);
      }

      if (
        testIDType == "sequential" &&
        test.startvalue &&
        test.endvalue &&
        test.prefix
      ) {
        let names = generateNames(
          test.prefix,
          test.startvalue,
          test.endvalue,
          2000,
          errors
        );
        if (names) {
          test.names = names;
          delete errors.startvalue;
          delete errors.endvalue;
        } else {
          errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
            errors.startvalue
          )} ]`;
          errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
            errors.endvalue
          )} ]`;
          if (testIDType != "import") test.names = null;
        }
      } else {
        if (testIDType != "import") test.names = null;
      }

      if (testIDType == "import" && tabPosition === 0) {
        delete errors.startvalue;
        delete errors.endvalue;
        delete errors.prefix;
        if (this.state.lantekfiles == null || this.state.test.names == null || this.state.test.names.length === 0) {
          errors.importFile = "Required";
        }
        else if (this.state.test.names.length > 2000) {
          errors.importFile = "LimitExceeded";
        }
        // validationData = {
        //   lantekfiles: {
        //     required: translate("formfield_error_general_required")
        //   }
        // };
      }

      const missingFieldName = Object.keys(errors)[0];
      if (missingFieldName) {
        const textField = document.getElementsByName(missingFieldName)[0];
        textField && textField.focus();

        if (Number.isInteger(parseInt(missingFieldName))) {
          toast.error(
            ` ${this.props.translate("test_create_invalid_identifier")}`,
            {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            }
          );
        }
      }
    }
    if (this.props.type === "fiber") {
      if (this.state.errors.lengthLimit || this.state.errors.lossLimit || this.state.errors.refractiveIndex) {
        return false;
      }
    }
    else if (this.state.errors.nvp) {
      return false;
    }
    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({
          errors,
          tabPosition: currentTab,
          tabView: tabs[currentTab]
        });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  editTest() {
    let isValidated = false
    let subtestValidation = false
    let errors = {}
    let { test, allowMetadataEdit } = this.state

    const { multiple, isCopper, isFiber, hasResult, onlyCopper, onlyFiber, allCoperHasResult, allFiberHasResult, partialResult } = this.props
    const { tabPosition, testCount, findreplacetestnames, addchangeengineer, findName, replaceName, engineerName } = this.state
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab)
      if (!isValidated) {
        return
      }
    }
    let validationData = test.metadata.map(x => {
      if (x.enabled && x.field != null && x.value.trim() === "") {
        errors[x.level] = true;
      } else if (x.enabled && x.field != null && x.value.length > 12) {
        errors[x.level] = true;
      }
    });
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
    } else {
      if (isValidated) {
        const { job, pager } = this.props

        if (!this.validate()) {
          return
        }
        if(allowMetadataEdit) {
          let metadata = [...test.metadata];
          metadata.map(e => {
            if (!e.enabled) {
              e.field = "";
              e.value = "";
              return e;
            }
          });
          test.metadata = metadata;
        }
        test.allowMetadataEdit = allowMetadataEdit

        this.props.type == "fiber"
          ? (test.interfaceid = 1)
          : ((this.props.type == "wifi")
          ? (test.interfaceid = 2)
          : (test.interfaceid = 0));

        if (!multiple) {
          if (isCopper || isFiber) {
            if (hasResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          }
        } else if (multiple) {
          if (onlyCopper) {
            if (allCoperHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else if (onlyFiber) {
            if (allFiberHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else {
            subtestValidation = false
          }
        }

        let signaltekeditdetails = {
          replace: findreplacetestnames,
          findName: findName,
          replacename: replaceName,
          addChangeengineer: addchangeengineer,
          engineerName: engineerName
        }

        if (testCount <= 0 && subtestValidation) {
          this.setState({ isSubTestError: true });
        } else {
          this.setState({
            editSaving: true,
            isSubTestError: false
          }, () => {
            this.props.saveEditTest({ ...test, signaltekeditdetails }, pager)
          })
        }
      }
    }
  }

  createTests() {
    let isValidated = false;
    const { tabPosition, testCount } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let { test, testIDType } = this.state;
      const { job, pager, userPreference } = this.props;

      if (!test.nvp) {
        test = { ...test, nvp: 0 };
      }

      if (
        job.metadatalookupid !== null &&
        job.metadatalookupid !== CUSTOM_METADATA_STANDARD
      ) {
        test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
      }

      //Remove Disabled Metadata
      if (job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      if (job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (userPreference && !userPreference.FromTreeview)) {
        var tempMetadata = test.metadata.map(i => {
          return { ...i, ...{ value: null } };
        });
        test = { ...test, metadata: tempMetadata };
      }
      this.props.type == "fiber"
      ? (test.interfaceid = 1)
      : ((this.props.type == "wifi")
      ? (test.interfaceid = 2)
      : (test.interfaceid = 0));
      if (testIDType === "import") {
        test.names = test.names.filter(
          (value, index) => test.names.indexOf(value) === index
        );
      }
      if (testCount <= 0) {
        this.setState({ isSubTestError: true });
      } else {
        this.setState({ isSubTestError: false });
        this.props.saveNewTests(test, pager);
      }
    }
  }

  handleErrors = (errors) => {
    this.setState({ errors });
  }

  addSubTestDetails = (type, details) => {
    let { test, testCount } = this.state;
    test[type] = true;
    test[type + "details"] = details;

    if (testCount <= 0) {
      ++testCount;
    }
    this.setState({
      test,
      testCount
    });
  };

  onTestPrefixTypeChange(e) {
    let test = { ...this.state.test };
    let testPrefixType = e.target.value;

    let errors = { ...this.state.errors };

    const { translate } = this.props;

    if (e.target.value !== "custom") {
      test.prefix =
        this.props.custom
          .find(cust => cust.level === 1)
          .values.find(obj => {
            return obj.id === e.target.value;
          }).name || "";
    } else {
      test.prefix = "";
    }
    if (test.startvalue && test.endvalue && test.prefix) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        10000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        test.names = null;
      }
    } else {
      test.names = null;
    }
    this.setState({
      test,
      testPrefixType
    });
  }

  onRestoreDetails = type => {
    this.props.getPingDetails(type);
    //this.setState({ isDetailsUpdated: false });
  };

  onTestIDTypeChange = e => {
    let { errors } = { ...this.state };
    let test = { ...this.state.test };
    //this.setState({ testIDType: e.target.value });
    if (e.target.value == "import") {
      errors.startvalue = false;
      errors.endvalue = false;
      errors.prefix = false;
    }
    errors.importFile = false;
    test.names = null;
    test.prefix = "";
    test.startvalue = "01";
    test.endvalue = "24";
    this.setState({
      testIDType: e.target.value,
      errors,
      test,
      testPrefixType: "custom",
      lantekfiles: null
    });
  };

  handleUpload() {
    let fd = new FormData();
    let lantekfiles = { ...this.state.lantekfiles };
    let { errors } = { ...this.state };
    Object.keys(lantekfiles).forEach(key => {
      fd.append("file", lantekfiles[key]);
    });
    errors.importFile = false;
    //alert("test");
    this.props.clearDuplicateError();
    this.props.uploadTestIDFile(fd);
    this.setState({
      errors
    });
    // this.props
    //   .uploadTestIDFile(fd)
    //   .then(resp => {
    //     // self.closeUploadLantekModal();
    //     // self.closeImportTestModal();
    //   })
    //   .catch(errors => {
    //     console.log("ERRRRRRR" + errors);
    //   });
  }

  handleImport(e) {
    let { errors } = { ...this.state };
    errors.importFile = false;
    this.setState({
      errors
    });
    if (e.target.type == "file" && e.target.files.length) {
      // const totalBytes = Object.keys(e.target.files).reduce(
      //   (total, file) => total + e.target.files[file].size,
      //   0
      // );
      // 1 MB = 1048576 bytes
      // if (Math.round(totalBytes / 1048576) >= APP_CONFIG.maxFileUploadSize) {
      //   toast.error(
      //     ` ${this.props.translate(
      //       "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast"
      //     )}`,
      //     {
      //       position: toast.POSITION.TOP_CENTER,
      //       hideProgressBar: true
      //     }
      //   );
      //   document.getElementById("lantekfiles").value = "";
      //   this.setState({
      //     lantekfiles: null,
      //     testFileArray: null,
      //     jobFileArray: null
      //   });
      //   return;
      // }
      this.setState({
        [e.target.name]: e.target.files
        // testFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() !== "job"
        // ),
        // jobFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() === "job"
        // )
      });
    }
  }

  render() {
    const { classes, translate, job } = this.props;

    let {
      custom,
      standards,
      error,
      type,
      userPreference,
      IDerrors,
      multiple,
      lengthMeasurementUnit
    } = this.props;

    let metadataOption;
    const {
      test,
      errors,
      tabs,
      testPrefixType,
      tabPosition,
      disabledToogleIdentifier,
      isSubTestError,
      tabView,
      selectedTestResult,
      selectedTrResult,
      editModalOpen,
      editModealOpen,
      isDetailsUpdated,
      testIDType,
      lantekfiles,
      modalRef
    } = this.state;

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch =
      this.state.test.metadata.filter(n => n.field).length !== 6;

    const { customerId } = this.props;
    return (
      <Modal open={this.props.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <DraggableModalFrame
            paperClassName={classes.modal}
            header={
              <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
              </ModalHeader>
            }
          >

            <ModalContents>
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {error && error === "error_testnamesize_exceeds_80chars" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {error && error === "nvp_out_of_range" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_nvp_out_of_range")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "invalid_character" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_char")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "maximum_length_exceed" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "too_many_test_to_import" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_numbers")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_wrongfiletype" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_type")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={translate(tab)} />;
                  })}
                </Tabs>
                {tabView === "tab_details" && (
                  <div className={classes.summary}>
                    {(job.metadatalookupid === null ||
                      job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) && (
                      <div>
                        <FormControl>
                          <RadioGroup
                            aria-label="chartLine"
                            name="chartLine"
                            className={classes.group}
                            value={testIDType}
                            onChange={this.onTestIDTypeChange}
                            row={true}
                          >
                            <FormControlLabel
                              value="sequential"
                              control={<Radio />}
                              label={translate("sequential_test_ids")}
                            />
                            <FormControlLabel
                              value="import"
                              control={<Radio />}
                              label={translate("import_test_ids")}
                            />
                          </RadioGroup>
                        </FormControl>
                        {testIDType === "import" && (
                          <div>
                            {/* <form
                              noValidate
                              autoComplete="off"
                              className={classes.form_inner}
                            > */}
                            <div className={classes.uploadlabel}>
                              <InputLabel
                                htmlFor="testPrefixType"
                                className={classes.fileUpload}
                              >
                                {translate("select_spreadsheet_to_import")}
                              </InputLabel>
                            </div>
                            <FormControl
                              fullWidth
                              error={errors.lantekfiles ? true : false}
                            >
                              <Input
                                className={classes.upload}
                                id="lantekfiles"
                                type="file"
                                name="lantekfiles"
                                onChange={this.handleImport}
                                inputProps={{
                                  name: "lantekfiles",
                                  multiple: false,
                                  accept: ".xlsx,.csv"
                                }}
                                error={errors.lantekfiles ? true : false}
                                helperText={
                                  errors.lantekfiles
                                    ? errors.lantekfiles
                                    : 'translate("test_custom_prefix_help")'
                                }
                              />
                              {/* <FormHelperText id="lantekfiles-helper-text">
                              {"Please Select a single file."}
                            </FormHelperText> */}
                            </FormControl>
                            {/* </form> */}
                            <Button
                              className={classes.import}
                              error={errors.importFile ? true : false}
                              raised
                              color="primary"
                              onClick={this.handleUpload}
                              disabled={lantekfiles == null}
                              helperText={
                                errors.importFile
                                  ? errors.importFile
                                  : 'translate("test_custom_prefix_help")'
                              }
                            >
                              {translate("general_import").toUpperCase()}
                            </Button>
                            {/* {$fileLists}
                          {$jobFile} */}
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <ul>
                                    <li>{translate("test_ids_tooltip_1")}</li>
                                    <li>{translate("test_ids_tooltip_2")}</li>
                                    <li>{translate("test_ids_tooltip_3")}</li>
                                    <li>{translate("test_ids_tooltip_4")}</li>
                                  </ul>
                                </React.Fragment>
                              }
                            >
                              <div className={classes.tooltip}>[?]</div>
                            </HtmlTooltip>
                            {(errors.importFile === "Required") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_required")}
                              </Typography>
                            )}
                            {(errors.importFile === "LimitExceeded") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_limit_exceeded")}
                              </Typography>
                            )}
                          </div>
                        )}
                        {testIDType === "sequential" && (
                          <FormControl
                            className={classes.textField}
                            margin="normal"
                          >
                            <InputLabel htmlFor="testPrefixType">
                              {translate("test_prefix")}
                            </InputLabel>
                            <Select
                              value={testPrefixType}
                              onChange={this.onTestPrefixTypeChange.bind(this)}
                              input={
                                <Input
                                  name="testPrefixType"
                                  id="testPrefixType"
                                  value={testPrefixType}
                                />
                              }
                              fullWidth
                            >
                              {custom
                                ? custom
                                    .find(c => c.level === 1)
                                    .values.map((c, index) => {
                                      return (
                                        <MenuItem
                                          key={`testPrefixType-${index}`}
                                          value={c.id}
                                        >
                                          {c.name}
                                        </MenuItem>
                                      );
                                    })
                                : null}
                              <MenuItem
                                key="testPrefixTypeCustom"
                                value="custom"
                              >
                                {translate("test_custom")}
                              </MenuItem>
                            </Select>
                            <FormHelperText>
                              {errors.cablestandard
                                ? errors.cablestandard
                                : translate("test_prefix_help")}
                            </FormHelperText>
                          </FormControl>
                        )}
                        {testIDType === "sequential" &&
                          testPrefixType === "custom" && (
                            <TextField
                              error={errors.prefix ? true : false}
                              required
                              name="prefix"
                              label={translate("test_custom_prefix")}
                              margin="normal"
                              fullWidth
                              value={test.prefix}
                              onChange={this.onChange}
                              inputProps={{
                                maxlength: 76
                              }}
                              helperText={
                                errors.prefix
                                  ? errors.prefix
                                  : translate("test_custom_prefix_help")
                              }
                            />
                          )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.startvalue ? true : false}
                            required
                            name="startvalue"
                            label={translate("test_startvalue")}
                            margin="normal"
                            fullWidth
                            value={test.startvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.startvalue
                                ? errors.startvalue
                                : translate("test_startvalue_help")
                            }
                          />
                        )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.endvalue ? true : false}
                            required
                            name="endvalue"
                            label={translate("test_endvalue")}
                            margin="normal"
                            fullWidth
                            value={test.endvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.endvalue
                                ? errors.endvalue
                                : translate("test_endvalue_help")
                            }
                          />
                        )}
                        {test.names && (
                          <React.Fragment>
                            <Grid container className={classes.testRange}>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption">
                                  {translate("test_ranges")}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption" align="right">
                                  {translate("test_ranges_total")} -
                                  <strong
                                    style={{ color: "rgba(0, 0, 0, 0.87)" }}
                                  >
                                    {test.names.length}
                                  </strong>
                                </Typography>
                              </Grid>
                            </Grid>
                            <List
                              disablePadding={true}
                              className={classes.scrollableList}
                            >
                              {test.names.map((val, i) => {
                                return (
                                  <ListItem key={`testnames-${i}`}>
                                    <ListItemText primary={val} />
                                  </ListItem>
                                );
                              })}
                            </List>
                          </React.Fragment>
                        )}
                      </div>
                    )}
                    {job.metadatalookupid &&
                      job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (
                        <div>
                          <div className={classes.summary}>
                            <TextField
                              error={errors.floor ? true : false}
                              required
                              name="floor"
                              label={translate("test_floor")}
                              margin="normal"
                              fullWidth
                              value={test.floor}
                              onChange={this.onChange}
                              helperText={
                                errors.floor
                                  ? errors.floor
                                  : translate("test_floor_help")
                              }
                            />

                            <TextField
                              error={
                                errors.telecommunicationspace ? true : false
                              }
                              required
                              name="telecommunicationspace"
                              label={translate("test_telecommunicationspace")}
                              margin="normal"
                              fullWidth
                              value={test.telecommunicationspace}
                              onChange={this.onChange}
                              helperText={
                                errors.telecommunicationspace
                                  ? errors.telecommunicationspace
                                  : translate(
                                      "test_telecommunicationspace_help"
                                    )
                              }
                            />
                            <TextField
                              error={errors.panel ? true : false}
                              required
                              name="panel"
                              label={translate("test_panel")}
                              margin="normal"
                              fullWidth
                              value={test.panel}
                              onChange={this.onChange}
                              helperText={
                                errors.panel
                                  ? errors.panel
                                  : translate("test_panel_help")
                              }
                            />

                            <TextField
                              error={errors.startvalue ? true : false}
                              required
                              name="startvalue"
                              label={translate("test_portstartvalue")}
                              margin="normal"
                              fullWidth
                              value={test.startvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.startvalue
                                  ? errors.startvalue
                                  : translate("test_portstartvalue_help")
                              }
                            />
                            <TextField
                              error={errors.endvalue ? true : false}
                              required
                              name="endvalue"
                              label={translate("test_portendvalue")}
                              margin="normal"
                              fullWidth
                              value={test.endvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.endvalue
                                  ? errors.endvalue
                                  : translate("test_portendvalue_help")
                              }
                            />
                          </div>
                          {test.names && (
                            <React.Fragment>
                              <Grid container>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption">
                                    {translate("test_ranges")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption" align="right">
                                    {translate("test_ranges_total")}
                                    {test.names.length}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <List
                                disablePadding={true}
                                className={classes.scrollableList}
                              >
                                {test.names.map((val, i) => {
                                  return (
                                    <ListItem key={`testnames-${i}`}>
                                      <ListItemText primary={val} />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            </React.Fragment>
                          )}
                        </div>
                      )}
                  </div>
                )}

                {(job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) &&
                  tabView === "tab_identifiers" && (
                    <div className={classes.summary}>
                      {showAllMetadataSwitch && (
                        <Typography type="subheading">
                          <FormControlLabel
                            control={
                              <Switch
                                name="allmetadataoptions"
                                checked={test.allmetadataoptions}
                                onChange={(e, checked) =>
                                  this.onToggleChange(e, checked)
                                }
                                disabled={disabledToogleIdentifier}
                              />
                            }
                            label={translate("test_add_metadata_item")}
                          />
                        </Typography>
                      )}

                      {custom &&
                        custom
                          .sort((a, b) => {
                            return a.level > b.level
                              ? -1
                              : a.level < b.level
                              ? 1
                              : 0;
                          })
                          .map((c, index) => {
                            metadataOption = test.metadata.find(
                              x =>
                                parseInt(x.level, 10) === parseInt(c.level, 10)
                            );
                            return (test.allmetadataoptions ||
                              metadataOption.default ||
                              metadataOption.enabled) &&
                              c.level !== 1 ? (
                              <div key={index}>
                                <Checkbox
                                  name={c.level}
                                  checked={metadataOption.enabled}
                                  onChange={this.onCustomCheckChange}
                                />
                                <select
                                  name={c.level}
                                  value={metadataOption.field}
                                  onChange={this.onCustomChange}
                                  disabled={!metadataOption.enabled}
                                >
                                  {c.values.map((o, index) => {
                                    return (
                                      <option key={index} value={o.id}>
                                        {o.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <TextField
                                  error={errors[c.level] ? true : false}
                                  required
                                  name={c.level}
                                  margin="normal"
                                  value={metadataOption.value}
                                  onChange={this.onChangeMetadataField}
                                  disabled={!metadataOption.enabled}
                                />
                              </div>
                            ) : null;
                          })}
                    </div>
                  )}
                {tabView === "tab_qualification" && (
                    <Qualification
                      selectedTest={"qualification"}
                      qualification={this.props.qualification}
                      translate={translate}
                      updateQualification={this.addSubTestDetails}
                      handleErrors={this.handleErrors}
                      isTestEdit={true}
                      showTestCreationCancelConfirmation={false}
                      onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                      hideTestCreationCancelConfirm={this.hideTestCreationCancelConfirm}
                      customerId={job.customerId}
                    />
                  )}
                {tabView === "tab_fiber_qualification" && (
                    <FiberQualification
                      selectedTest={"fiberlengthloss"}
                      fiberQualification={this.props.fiberQualification}
                      translate={translate}
                      updateFiberQualification={this.addSubTestDetails}
                      handleErrors={this.handleErrors}
                      isTestEdit={true}
                      showTestCreationCancelConfirmation={false}
                      onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                      hideTestCreationCancelConfirm={this.hideTestCreationCancelConfirm}
                      customerId={job.customerId}
                      lengthMeasurementUnit={lengthMeasurementUnit}
                    />
                  )}
              </form>
            </ModalContents>

            <ModalFooter>
              {isSubTestError == true ? (
                <Typography className={classes.sterror}>
                  {translate("add_cust_subtest_required")}
                </Typography>
              ) : null}
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.createTests()}
                  type="submit"
                  disabled={
                    testIDType === "import" && Object.keys(IDerrors).length != 0
                  }
                >
                  {translate("test_create")}
                </Button>
              ) : null}
            </ModalFooter>
          </DraggableModalFrame>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { testNameList, qualification } = nextProps;
    let test = { ...this.state.test };
    if (this.props.testNameList !== testNameList) {
      test.names = testNameList;
      this.setState({
        test
      });
    }
    if (qualification && this.props.qualification !== qualification) {
      this.setState({ qualification });
    }
  }

  componentDidMount() {
    const { test } = this.state;
    const { userPreference } = this.props;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentWillMount() {
    this.props.getQualification();
    this.props.getFiberQualification();
  }
}

const mapStateToProps = state => ({
  qualification: state.subtestReducer.qualification,
  fiberQualification: state.subtestReducer.fiberLengthLoss,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getQualification: () => {
    dispatch(getQualification());
  },
  getFiberQualification: () => {
    dispatch(getFiberLengthLoss("qualification"));// parameter indicates qualification test
  }
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NewQualificationTest)
);
